export default __webpack_public_path__ + "static/media/cocktail.8c20d3e9.jpeg";